import React from 'react';
import PhototherapyApp from './PhototherapyApp';
import { PHOTOTHERAPY_VARIANT } from './variants';

/**
 * "צהבת ביילוד" — the original jaundice app, at `/main/<hospital>/phototherapy`.
 *
 * All behaviour lives in `PhototherapyApp.tsx`; this app only binds the
 * `PHOTOTHERAPY` variant, so it reads its own AppConfig rows and defaults to the
 * Israeli curves. See `variants.ts` and `Bili2022/Bili2022.tsx`.
 */
export const Phototherapy: React.FC<{ hospital?: string }> = ({ hospital }) => (
  <PhototherapyApp hospital={hospital} variant={PHOTOTHERAPY_VARIANT} />
);

export default Phototherapy;
